export default __webpack_public_path__ + "static/media/home_news_active.bff6e732.svg";